<template lang="html">
  <div class="user shadow border relative">
    <p>You are currently viewing your own {{ $attrs.type }}</p>

    <span
      v-if="$attrs.status == 'stop'"
      class="flex absolute m-2 top-0 right-0 text-xs"
    >
      <span class="bg-red-600 rounded-full inline-block w-6 h-6"></span>
      <span class="p-1 inline-block leading-relaxed"> Closed </span></span
    >

    <span
      v-if="$attrs.status == 'pause'"
      class="flex absolute m-2 top-0 right-0 text-xs"
    >
      <span class="bg-orange-600 rounded-full inline-block w-6 h-6"></span>
      <span class="p-1 inline-block leading-relaxed"> Paused </span></span
    >

    <span
      v-if="$attrs.status == 'live'"
      class="flex absolute m-2 top-0 right-0 text-xs"
    >
      <span class="bg-green-600 rounded-full inline-block w-6 h-6"></span>
      <span class="p-1 inline-block leading-relaxed"> Live </span></span
    >

    <span v-if="$attrs.status" class="controls block m-4">
      <p class="mb-4">Control poll display</p>
      <button
        v-if="$attrs.number != 0"
        @click="prev($attrs.number)"
        type="button"
        class="p-2 bg-push-blue text-white"
        name="button"
      >
        Previous Poll
      </button>
      <button
        v-if="$attrs.total > $attrs.number + 1"
        @click="next($attrs.number)"
        type="button"
        class="p-2 bg-push-blue text-white"
        name="button"
      >
        Next Poll
      </button>
      <p class="mt-4">Control event status</p>
      <span class="flex mx-auto table p-4">
        <button
          @click="eventStatus('pause')"
          type="button"
          class="inline-block py-2 px-4 m-1 shadow-lg border rounded bg-orange-600 text-white"
          name="button"
        >
          Pause
        </button>
        <button
          @click="eventStatus('live')"
          type="button"
          class="inline-block py-2 px-4 m-1 shadow-lg border rounded bg-green-600 text-white"
          name="button"
        >
          Go Live
        </button>
        <button
          @click="eventStatus('stop')"
          type="button"
          class="inline-block py-2 px-4 m-1 shadow-lg border rounded bg-red-600 text-white"
          name="button"
        >
          Stop
        </button>
      </span>
    </span>
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
  methods: {
    eventStatus(status) {
      var vm = this;
      var id = vm.$route.params.groupId;
      var firestore = firebase.firestore();
      var docRef = firestore.collection("groups").doc(String(id));
      docRef
        .update({
          event: status
        })
        .then(function() {
          console.log("Document successfully updated status!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    next(number) {
      this.$emit("countNumber", Number(number + 1));
      var vm = this;
      var id = vm.$route.params.groupId;
      var firestore = firebase.firestore();
      var docRef = firestore.collection("groups").doc(String(id));
      docRef
        .update({
          eventpoll: Number(number + 1)
        })
        .then(function() {
          console.log("Document successfully updated number!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    prev(number) {
      this.$emit("countNumber", Number(number - 1));
      var vm = this;
      var id = vm.$route.params.groupId;
      var firestore = firebase.firestore();
      var docRef = firestore.collection("groups").doc(String(id));
      docRef
        .update({
          eventpoll: Number(number - 1)
        })
        .then(function() {
          console.log("Document successfully updated number!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    }
  }
};
</script>

<style lang="css"></style>
